'use client';

import { usePathname } from 'next/navigation';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import { isBookingPath } from '@/lib/locale';

export default function AppChrome({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const inBookingApp = isBookingPath(pathname);

  if (inBookingApp) {
    return <>{children}</>;
  }

  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}
